import { FC } from "react";
import styles from './CategoryButton.module.css';

interface CategoryButtonProps {
    title: string;
    selected: boolean;
    image: string;
    blue: boolean;
}

export const CategoryButton: FC<CategoryButtonProps> = ({title, selected, image, blue}: CategoryButtonProps) => {

    return <div className={[styles.categoryButton, blue? styles.blue : ''].join(' ')} aria-label={title}>

        <div className={(selected ? [styles.button, styles.selected] : [styles.button]).join(' ')}>
            <div className={[styles.circle, blue? styles.blue : ''].join(' ')}></div>
            <div className={[styles.outline, blue? styles.blue : ''].join(' ')}></div>
            <img src={image} alt="" />
            {selected && <span className={styles.checkBadge} aria-hidden="true">✓</span>}
        </div>
        <div>{title}</div>

    </div>;
}
